import React, { useContext } from 'react';
import { ApiContext } from '../../../UseContext/ApiCall';
import { Modal } from 'react-bootstrap';
import { AwsFileUrl, BASE_URL_STATIC } from '../../../../../config';



const PostViewUsersPopup = () => {

  const {
    showPostViewUsersPopup, setShowPostViewUsersPopup,
    postViewUsers, setPostViewUsers,
    postViewUserText, setPostViewUserText,
    postViewUserPostId, setPostViewUserPostId,
    showPostViewUserLoadMore, setShowPostViewUserLoadMore,
    getPostViewUsers,
  } = useContext(ApiContext);

  // handle change
  const handleSearchChange = (e) => {
    const { value } = e.target;

    setPostViewUserText(value);

    getPostViewUsers(postViewUserPostId, value, 0);
  };

  // handle click load more
  const handleClickLoadMore = () => {
    setShowPostViewUserLoadMore(false);

    getPostViewUsers(postViewUserPostId, postViewUserText, postViewUsers.length);
  };
  
  // handle close popup
  const handleClosePopup = () => {
    setShowPostViewUsersPopup(false);
    setPostViewUsers([]);
    setPostViewUserPostId('');
  };


  return (
    <>
      <Modal show={showPostViewUsersPopup} onHide={handleClosePopup} centered backdrop="static" keyboard={false} className="main-modal" >
        <Modal.Header className='pt-0' closeButton>
          <h5 className='flex-grow-1 text-center pt-3'>Post View Users</h5>
        </Modal.Header>

        <Modal.Body>
          {/* Search Bar */}
          <div className="d-flex flex-grow-1 rounded-pill bg-body-secondary p-1 p-sm-2 mt-3 mb-4">
            <img className="mx-2" src={`${BASE_URL_STATIC}/icon/search.svg`} alt="search" />

            <input type="search" className="rounded-pill bg-body-secondary w-100 border-0" id="search" name="search" autoComplete='false' placeholder="Search..." 
              value={postViewUserText} onChange={handleSearchChange}
            />
          </div>
  
          {/* Users List */}
          <div className='overflow-y-scroll pe-1' style={{ maxHeight: '40vh' }}>
            {
              (postViewUsers && postViewUsers.length > 0)
              &&
              postViewUsers.map((value, index) => (
                <div className='d-flex gap-3 align-items-center mb-3' key={index}>
                  <img src={`${AwsFileUrl+value.profile}`} style={{ height: '40px', width: '40px' }} className='rounded-circle' alt="profile" />

                  <div className='me-auto'>
                    <h5 className='mb-0'>{value.fullName}</h5>
                    <span className='text-secondary'>{value.userName}</span>
                  </div>

                  {
                    value.buttonText !== ''
                    &&
                    <button type="button" className='btn btn-primary btn-sm'>{value.buttonText}</button>
                  }
                </div>
              ))
            }

            {/* Load More */}
            {
              showPostViewUserLoadMore
              ?
              <div className='mt-3 mb-1 text-center'>
                <button type="button" className='btn btn-primary btn-sm' onClick={handleClickLoadMore}>Load More</button>
              </div>
              :
              <div className='text-center text-secondary'>No users...</div>
            }
          </div>
        </Modal.Body>
      </Modal>  
    </>
  )
}

export default PostViewUsersPopup